import { createQueryParams } from '@nexio/emvio-util-app';
import config from '../../config/config';
import { buildTableSuccessActionBasedOnCount } from '../../utils/actionCreators';
import { navigateToMerchantDetails } from './utils/navigationUtils';
import {
    APPLICATIONS_LOAD,
    APPLICATIONS_SUCCESS,
    APPLICATIONS_FAILURE
} from './applicationEntity';

export const fetchApplicationsUrl = `${config.underwritingApiUrl}/onboarding/applications`;

export function getApplications(filters, page, pageSize, sorters) {
    const queryParamsString = createQueryParams({
        filters,
        page,
        pageSize,
        sorters
    });

    return {
        failureActionTypeOrCreator: getApplicationsFailureActionCreator,
        fetchParams: {
            url: `${fetchApplicationsUrl}${queryParamsString}`
        },
        loadActionTypeOrCreator: APPLICATIONS_LOAD,
        successActionTypeOrCreator: getApplicationsSuccessActionCreator
    };
}

export function getApplicationsSuccessActionCreator(results) {
    return buildTableSuccessActionBasedOnCount(results, APPLICATIONS_SUCCESS, 'applications');
}

export function getApplicationsFailureActionCreator(error) {
    return {
        error,
        type: APPLICATIONS_FAILURE
    };
}

export function selectApplication(history, application) {
    navigateToMerchantDetails(history, application.onboardingId);
}
